import React, { memo } from 'react';
import { string, func } from 'prop-types';
import { Alert, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

import './styles.scss';

const severityByType = {
  danger: 'error',
  warning: 'warning',
  success: 'success',
  info: 'info',
};

const ErrorPanel = ({ message, buttonClickHandler, type, dataTestId = 'error-panel' }) => (
  <Alert
    severity={severityByType[type] || severityByType.danger}
    className="error-panel"
    data-testid={`${dataTestId}-panel`}
    action={
      <IconButton
        className="cross-icon-container"
        size="small"
        color="inherit"
        onClick={buttonClickHandler}
        data-testid={`${dataTestId}-button`}
        aria-label="Close error message"
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    }
  >
    <span data-testid={`${dataTestId}-message`}>{message}</span>
  </Alert>
);

ErrorPanel.propTypes = {
  type: string,
  message: string.isRequired,
  buttonClickHandler: func.isRequired,
  dataTestId: string,
};

export default memo(ErrorPanel);
